import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import * as moment from 'moment';
import { concatMap, filter, map } from 'rxjs/operators';
import { LayoutService } from '../../../@core/data/layout.service';
import { AuthGuard } from '../../../@core/guards/auth.guard';
import { ModalsHandlerService } from '../../../pages/modals/modals.handler.service';
import { AnalyticsConstants } from '../../../shared/constants/Analytics';
import { Filter } from '../../../shared/constants/Filters';
import { NoticeDto } from '../../../shared/models/admin/notice.dto';
import { ChangeCompanyInput } from '../../../shared/models/company/changeCompany.input';
import { RolType } from '../../../shared/models/types/rol.types';
import { NoticesService } from '../../../shared/services/admin/notices.service';
import { ChatService } from '../../../shared/services/chat/chat.service';
import { CompanyService } from '../../../shared/services/company/company.service';
import { CsvGeneratorService } from '../../../shared/services/csv-generation/csv-generator.service';
import { EventService } from '../../../shared/services/event/event.service';
import { AuthService } from '../../../shared/services/security/auth.service';
import { TrackAnalyticsService } from '../../../shared/services/track-analytics/track-analytics.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit, AfterViewInit {

  @Input() position = 'normal';

  user: any;

  userMenu = [
    { title: this.translatorService.trans('auth.profile'), link: '/profile' },
    { title: this.translatorService.trans('auth.labels.logout'), link: '/auth/logout' },
  ];
  notificationsItems: any[];
  placeholder: string;
  newLeadTitle: string;
  selectCompanyTitle: string;
  companySelected: any;
  context: any = null;
  rolType: RolType = new RolType();
  downloadStatus: any;
  downloadInProgress: boolean;
  title: string;
  notices: NoticeDto[];
  ctx: { notices: NoticeDto[]; };
  unread: number;

  private readonly DEFAULT_LOGO_PATH = 'default/logo_dmsvo.png';

  constructor(
    private readonly sidebarService: NbSidebarService,
    private readonly layoutService: LayoutService,
    readonly authGuard: AuthGuard,
    readonly authService: AuthService,
    private readonly modalHandler: ModalsHandlerService,
    private readonly translatorService: TranslatorService,
    private readonly nbMenuService: NbMenuService,
    private readonly chatService: ChatService,
    private readonly companyService: CompanyService,
    private readonly eventService: EventService,
    private readonly cdr: ChangeDetectorRef,
    readonly csvGenerator: CsvGeneratorService,
    private readonly noticesService: NoticesService,
    protected readonly trackAnalytics: TrackAnalyticsService,
    //private readonly supportService: SupportService,
  ) {

    // TODO Review responsive context menu
    // if (this.authService.isTestAB()) {
    //   this.userMenu.unshift({ title: this.translatorService.trans('auth.profile'), link: '/profile' });
    // }

  }
  ngAfterViewInit(): void {
    this.setLogoIfCompanyHasAPath();
  }

  ngOnInit(): void {

    this.setUserDefaults();

    this.noticesService.init();
    this.noticesService.notices.subscribe((notices: NoticeDto[]) => {
      this.notices = notices;
      this.unread = notices.filter((notice) => !notice.readed).length;
    });

    this.placeholder = 'globals.select';
    this.selectCompanyTitle = this.translatorService.trans('header.select_company');
    this.authService.resfreshNewUser.subscribe(() => {
      this.setUserDefaults();
    });
    this.downloadStatus = {
      percent: 0
    };
    this.eventService.subscribe('downloadStep', status => {
      this.downloadInProgress = true;
      this.downloadStatus = status;
      this.downloadStatus.percent = Math.floor(status.progress * 100 / status.totalPage);
    });
    this.eventService.subscribe('downloadFinished', () => {
      this.downloadInProgress = false;
    });

  }

  setUserDefaults(): void {
    this.user = this.authService.getUser();
    if (!this.user) {
      return;
    }
    this.translatorService.setLanguage(this.user.language);
    moment.locale(this.user.language);
    this.companySelected = this.user.company;
    this.setCompanyTitle();
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    this.syncBodyScrollWithSidebar();

    return false;
  }
  newLead(): void {
    this.modalHandler.openNewLeadModal();
  }

  onDeSelect(event: any): void {
    this.context.companySelected = event;
  }

  onItemSelect(event: any): void {

    const changeCompanyInput = new ChangeCompanyInput();
    changeCompanyInput.companyId = event.id;

    this.companyService.changeCompany$(changeCompanyInput).pipe(
        concatMap(() => this.context.authService.refreshToken(this.context.user.email))
    ).subscribe(() => {

      this.context.companySelected = event;
      this.context.user.company = event;
      this.context.authService.setUser(this.context.user);
      localStorage.removeItem(Filter.DASHBOARD);
      localStorage.removeItem(Filter.SALES);
      localStorage.removeItem(Filter.MARKETING);
      localStorage.removeItem(Filter.LEADS);
      location.reload();
    }, error => {
      this.context.toasterService
        .showToast(
          'error',
          'Error',
          this.context.errorFormatter.formatErrors(error.graphQLErrors)
        );

    });
  }

  private setCompanyTitle() {
    this.title = this.user.company.name;

    if (this.title.length >= 20) {
      this.title = this.title.slice(0, 20) + '...';
    }
  }

  detectClick() {
    if (this.unread === 0) {
      this.trackAnalytics.sendEvent(AnalyticsConstants.CATEGORY_FEATURE, AnalyticsConstants.READ_NOTICES);
    } else {
      this.trackAnalytics.sendEvent(AnalyticsConstants.CATEGORY_FEATURE, AnalyticsConstants.UNREAD_NOTICES);
    }
  }

  private setLogoIfCompanyHasAPath() {
    const company = this.user.company;
    const logoContainer = document.getElementById('logo-header-container');

    logoContainer.style.backgroundImage = company.companyConfiguration && company.companyConfiguration.logoPath ?
     `url(assets/images/logo/${company.id}/${company.companyConfiguration.logoPath})`
     : `url(assets/images/logo/${this.DEFAULT_LOGO_PATH})`;
  }

  private syncBodyScrollWithSidebar(): void {
    setTimeout(() => {
      const sidebar = document.getElementById('sidebarId');
      const shouldLockScroll = sidebar && sidebar.classList.contains('expanded');
      document.body.style.overflow = shouldLockScroll ? 'hidden' : '';
      document.documentElement.style.overflow = shouldLockScroll ? 'hidden' : '';
    });
  }
}
